import { call, put, takeLatest } from "redux-saga/effects";
import {
  deleteMeasurement as deleteMeasurementApi,
  saveMeasurement as saveMeasurementApi,
} from "../../../services/coilConfiguratorApi";
import type { MeasurementRecord } from "../../../web-app";
import { showToast } from "../actions";
import {
  DELETE_MEASUREMENT,
  MEASUREMENT_SAVE_FAILURE,
  MEASUREMENT_SAVE_SUCCESS,
  SAVE_APPLICATION_STATE_SUCCESS,
  UPSERT_MEASUREMENT,
} from "../types";

function* upsertMeasurementSaga(
  action: { type: typeof UPSERT_MEASUREMENT; record: MeasurementRecord; fromModal?: boolean },
): Generator {
  try {
    yield call(saveMeasurementApi, action.record);
    const updatedAt = new Date().toISOString();
    yield put({ type: SAVE_APPLICATION_STATE_SUCCESS, updatedAt });
    yield put({ type: MEASUREMENT_SAVE_SUCCESS });
    yield put(showToast("Measurement saved successfully."));
  } catch (error) {
    const message = error instanceof Error ? error.message : "Failed to save measurement";
    yield put({ type: MEASUREMENT_SAVE_FAILURE });
    yield put(showToast(message, "error"));
  }
}

function* deleteMeasurementSaga(action: { type: typeof DELETE_MEASUREMENT; id: string }): Generator {
  try {
    yield call(deleteMeasurementApi, action.id);
    const updatedAt = new Date().toISOString();
    yield put({ type: SAVE_APPLICATION_STATE_SUCCESS, updatedAt });
    yield put(showToast("Measurement deleted."));
  } catch (error) {
    const message = error instanceof Error ? error.message : "Failed to delete measurement";
    yield put(showToast(message, "error"));
  }
}

function* measurementsWatcher(): Generator {
  yield takeLatest(UPSERT_MEASUREMENT, upsertMeasurementSaga);
  yield takeLatest(DELETE_MEASUREMENT, deleteMeasurementSaga);
}

export default measurementsWatcher;
